import { Dispatch, useEffect } from 'react';
import { AppAction } from './startReducer';

export type FrameAction = {
    isEdulla: boolean,
    action: string,
    data: any
}

const isIFrame = (input: HTMLElement | null): input is HTMLIFrameElement =>
    input !== null && input.tagName === 'IFRAME';

export function useIframe(dispatch: Dispatch<AppAction>) {

    const postMessageToFrame = (msg: any) => {
        let frame = document.getElementById('edullaChatWidgetFrame');
        if (isIFrame(frame) && frame.contentWindow) {
            frame.contentWindow.postMessage(msg, "*");
        }
    }


    useEffect(() => {
        const onMessageReceivedFromIframe = (e: any) => {
            let msgData = e.data;
            if (msgData && msgData.isEdulla) {
                switch (msgData.action) {
                    case 'edullaChatState':
                        dispatch({ type: "setEnteredInformation", hasEnteredInformation: msgData.data.enteredInformation })
                        break;
                    case 'setLastLocation':
                        dispatch({ type: "setLastLocation", location: msgData.data })
                        break;
                    case 'closeWidget':
                        dispatch({ type: "setShowChat", showChat: false })
                        break;
                    case 'shrinkWidget':
                        dispatch({ type: "setShrinkWidget", shrinkWidget: msgData.data })
                        break;
                }
            }
        }
        window.addEventListener("message", onMessageReceivedFromIframe);
        postMessageToFrame({ isEdulla: true, action: "requestState" });
    }, [dispatch]);
    return postMessageToFrame;
}
